module.exports = __webpack_public_path__ + "img/ketten_btn.6ba5a4f4.jpg";